module.exports = __webpack_public_path__ + "static/media/info.012f617d.svg";